import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { fetchData } from '../../../helpers/methods';

import SpinnerContainer from '../../../component-library/spinner-container';
import Tile from '../../../component-library/tile';

const Metrics = ({
	id,
	title,
}) => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState({});
	const [source, setSource] = useState({});

	const getData = () => {
		fetchData({
			uri: `/api/web/catalog/item/${id}/metrics/headlines`,
			method: 'GET',
		})
			.then(res => {
				const sourceData = res.body.storefront?.details?.nonNativeMetrics;
				const metricsData = res.body.headlines;
				setData(metricsData);
				setSource(sourceData);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<>
			<h3>{title}</h3>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				<>
					<div className="metrics__grid margin-bottom-24">
						{data?.length ? (
							data.map((metric, index) => (
								// eslint-disable-next-line react/no-array-index-key
								<Tile key={index}>
									<div title={metric.description}>
										<h3 className="text-center text-capitalize">
											{metric.label}
										</h3>
										<div className="metrics__card-value">
											{metric.value > 0 && metric.value < 1 && (
												(Math.round(metric.value * 1000000) / 1000000).toLocaleString('en-US')
											)}
											{(metric.value === 0 || metric.value === '0' || metric.value === '0.0' || metric.value >= 1) && (
												Math.round(metric.value).toLocaleString('en-US')
											)}
										</div>
										<div className="metrics__card-units">
											{metric.metric.unitOfMeasure}
										</div>
									</div>
								</Tile>
							))
						) : (
							<p className="grey-text">No metrics found</p>
						)}
					</div>
					{source && (
						<p>
							<em className="grey-text">Metrics data provided by SPLUNK</em>
						</p>
					)}
				</>
			)}
		</>
	);
};

export default Metrics;

Metrics.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
};
